import * as React from "react";
import { Alert } from '@cmsgov/design-system-core';

const ErrorMessage = ({error}: any) => {
  if (error && error.message !== '') {
    return (
      <Alert heading="System Error" variation="error">
        { error.message }
      </Alert>
    );
  } else {
    return (
      null
    );
  }
};

export default ErrorMessage;
